import React from 'react'

import { Portlet, Table, Row, Col, Form } from '_zari/core'

import * as InventarioService from 'services/inventario.service'

const portletBreadcrumbs = [{ name: 'Consulta Producto' }]

const ConsultaProductoPage = ({ match }) => {
  const [infoProducto, setInfoProducto] = React.useState(null)

  React.useEffect(() => {
    InventarioService.getConsultaxIdProducto(match.params.idProducto).then(({ data }) => {
      setInfoProducto(data)
    })
  }, [match.params.idProducto])

  return (
    <>
      {infoProducto && (
        <Portlet>
          <Portlet.Header title='Consulta Producto' breadcrumbs={portletBreadcrumbs} />
          <Portlet.Body>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label text='PRODUCTO' md={4} />
                  <Col md={8}>
                    <Form.InputText
                      id='readonly-producto'
                      name='readonly-producto'
                      defaultValue={`${infoProducto.codigoProducto} - ${infoProducto.nombreProducto}`}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Table
              maxRowsShown={10}
              filas={infoProducto.detalles}
              headRows={[
                { label: 'TRANSACCIÓN' },
                { label: 'FECHA' },
                { label: 'INGRESO' },
                { label: 'SALIDA' },
                { label: 'SALDO' },
                { label: 'PRESENTACION' },
                { label: 'SUCURSAL' },
                { label: 'NUMERO DOC' },
                { label: 'RAZON SOCIAL' },
              ]}
              rowTemplate={row => (
                <Table.Row hover key={row._id}>
                  <Table.Cell>{row.transaccion || '--'}</Table.Cell>
                  <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
                  <Table.Cell>{row.montoEntrada || '--'}</Table.Cell>
                  <Table.Cell>{row.montoSalida || '--'}</Table.Cell>
                  <Table.Cell>{row.sumaConjunta || '--'}</Table.Cell>
                  <Table.Cell>{row.presentacion || '--'}</Table.Cell>
                  <Table.Cell>{row.sucursal || '--'}</Table.Cell>
                  <Table.Cell>{row.numeroDocumento || '--'}</Table.Cell>
                  <Table.Cell>{row.razSoc || '--'}</Table.Cell>
                </Table.Row>
              )}
            />
          </Portlet.Body>
        </Portlet>
      )}
    </>
  )
}

export default React.memo(ConsultaProductoPage)
